<template>
  <v-card elevation="2" outlined>
    <v-card-title>
      <v-container>
      <v-row >
        <v-col :align-self="'center'" :cols="3">
          <v-checkbox
              v-if="$attrs.editable"
              v-model="image.selected"
              dense
              :label="`${image.selected ? `Selected` : `Select`}`"
          />
        </v-col>
        <v-col :align-self="'center'" :cols="4">
          <v-checkbox
              v-if="isQc === false"
              v-model="image.needs_review"
              dense
              label="Needs Review"
              @change="logReview"
          />
        </v-col>
        <v-col v-if="$attrs.editable" :align-self="'center'" :cols="5" class="mb-2">
          <v-chip :color="image.tagged ? `primary` : `secondary`" class="text-white float-right mb-2" >Status:
            {{ image.tagged ? `Tagged` : `Not Tagged` }}
          </v-chip>
          <v-chip v-if="image.needs_review" :color="`warning`" class="text-white float-right"> Needs Review
          </v-chip>
        </v-col>

      </v-row>



      </v-container>
      </v-card-title>
    <v-card-text>

        <image-zoom
          class="mb-3"
          :regular="image.image_url"
          :zoom="image.image_url"
          :zoom-amount="4"
          :click-zoom="true"
          img-class="tag-image"
          >
        </image-zoom>
      <v-spacer></v-spacer>
      <div v-if="$attrs.editable === true && isSa === false">
        <v-chip
            v-for="tag in visibleImageTags" :key="tag.id"
            class="ma-2"
            close
            @click:close="removeTag(tag)"
        >
          {{ tag.name }}
          <v-chip
              props: x-small
              outlined
              style="border-width: 0;"
          >
            <v-spacer>{{ tag.category?.name }}</v-spacer>
          </v-chip>
        </v-chip>
      </div>

      <div v-else>
        <v-chip
            v-for="tag in image.tags" :key="tag.id"
            class="ma-2"
        >
          {{ tag.name }}
          <v-chip
              props: x-small
              outlined
              style="border-width: 0;"
          >
            <v-spacer>{{ tag.category?.name }}</v-spacer>
          </v-chip>
        </v-chip>
      </div>

      <div v-if="$attrs.editable == true">
        <v-btn color="primary" depressed @click="showTaggerModal = true">Add Tag</v-btn>
        <TaggerModal v-if="showTaggerModal"
                     v-model="showTaggerModal" :photo="image" :isQc="isQc"
                     @close="showTaggerModal = false"
        />
      </div>
    </v-card-text>
    <!--  -->
    <v-card-text v-if="$attrs.editable == true">
      <v-list dense>
        <v-list-item v-if="isQc">Tagger: {{ image.tagger }}</v-list-item>
        <v-list-item>Response ID: {{ image.response_id }}</v-list-item>
        <v-list-item>Date Acquired: {{ image.date_acquired | formatDate }}</v-list-item>
        <v-list-item v-if="isQc && image.tagged"> First Tagged: {{ image.date_first_tagged | formatDate }}</v-list-item>
        <v-list-item v-if="isQc && image.tagged"> Last Tagged: {{ image.date_tagged | formatDate }}</v-list-item>
        <v-list-item>Project: {{ image.project_id }}</v-list-item>
        <v-list-item>Job: {{ image.job_id }}</v-list-item>
        <v-list-item>Notes: {{ image.notes }}</v-list-item>
      </v-list>
    </v-card-text>

    <slot></slot>
  </v-card>
</template>

<script>

import moment from 'moment'

import {mapActions, mapGetters} from 'vuex'
import TaggerModal from '../modals/TaggerModal'
import imageZoom from 'vue-image-zoomer';

export default {
  name: 'PhotoCard',
  components: {
    TaggerModal,
    imageZoom,
  },
  props: {
    image: Object,
    isQc: {
      type: Boolean,
      default: false
    },
    isSa: {
      type: Boolean,
      default: false
    }
  },
  filters: {
    formatDate: function (val) {
      return moment(val).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  computed: {
    // IT-704 (P4): chips are a removable input, so machine-owned (derived) tags
    // are hidden from the editable card once derivation is enabled. The
    // read-only (non-editable / SA) branch below keeps showing every tag.
    ...mapGetters(['retainHumanTags']),
    visibleImageTags() {
      return this.retainHumanTags(this.image.tags)
    }
  },
  methods: {
    ...mapActions(['bulkUpdate', ]),

    removeTag(selected_tag) {

      let index = this.image.tags.indexOf(selected_tag)
        if (index >= 0) this.image.tags.splice(index, 1)
      // IT-704 (P4): when derivation is on, send only human-picked tags — the
      // backend recomputes the derived ones. A no-op when it is off.
      let activeTagIds = this.retainHumanTags(this.image.tags).map(tag => tag.id)
      let payload = {
        selected_photos: [this.image.id],
        selected_tags: activeTagIds,
        needs_review: this.image.needs_review,
        isQc: this.isQc
      }
      this.bulkUpdate(payload).then(() => {

      })
    },
    logReview() {
      let activeTagIds = this.retainHumanTags(this.image.tags).map(tag => tag.id)
      let payload = {
        selected_photos: [this.image.id],
        selected_tags: activeTagIds,
        needs_review: this.image.needs_review,
        isQc: this.isQc
      }

      this.bulkUpdate(payload).then(() => {
      })
    }
  },
  data() {
    return {
      showTaggerModal: false,
      photo: null,
      inQc: this.isQc
    }
  }
}
</script>

<style>
@media (min-width: 960px) {
  .tag-image{
  max-width:400px;
}
}
@media (min-width: 1264px) {
  .tag-image{
  max-width:530px;
}
}
@media (min-width: 1904px) {
  .tag-image{
  max-width:540px;
}
}

</style>
